/* ============================================================
   MISHA — 2026 redesign · shared behaviour (m26.js)
   Ported from the prototype's misha.js + chrome.js wiring.
   The prototype's demo catalog + localStorage cart are replaced
   with Shopify's AJAX Cart API (/cart.js, /cart/add.js, etc.)
   and predictive search (/search/suggest.json).

   Namespaced under window.M26. Every initialiser is null-safe so
   this file can load on any page, with or without the chrome.
   ============================================================ */
(function () {
  'use strict';

  var M26 = (window.M26 = window.M26 || {});
  var cfg = M26.config || {};
  M26.config = cfg;

  /* ---------- helpers ---------- */
  function ready(fn){ if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  function $(sel, ctx){ return (ctx || document).querySelector(sel); }
  function $all(sel, ctx){ return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  // Locale/market root, e.g. "/en-au/" on the AU storefront and "/" on the primary
  // market. Shopify sets window.Shopify.routes.root on every storefront page; the
  // Liquid layer also passes routes.root_url as a fallback. Every storefront request
  // (search suggest, cart, product data) MUST go through here, otherwise it hits the
  // primary market and comes back with the wrong currency + non-localised product URLs
  // — which sends /en-au shoppers to the USD site.
  M26.root = (window.Shopify && Shopify.routes && Shopify.routes.root) || cfg.root || '/';
  function rootUrl(path){
    return M26.root.replace(/\/+$/, '') + '/' + String(path).replace(/^\/+/, '');
  }
  M26.url = rootUrl;

  // Idempotently ensure an internal path carries the locale/market root. API responses
  // (e.g. /search/suggest.json) sometimes return product URLs without the subfolder;
  // navigating to those drops the shopper out of /en-au. External/absolute URLs and
  // already-localised paths are returned unchanged.
  function localize(url){
    if (!url || url.charAt(0) !== '/' || url.charAt(1) === '/') return url; // empty, external, or protocol-relative
    var base = M26.root.replace(/\/+$/, ''); // "/en-au" or "" on the primary market
    if (!base) return url;
    if (url === base || url.indexOf(base + '/') === 0) url = url.slice(base.length) || '/';
    return base + url;
  }
  M26.localize = localize;

  // Money formatting. The Liquid layer sets M26.config.moneyFormat (shop money_format)
  // and M26.config.currency. Cart prices arrive from Shopify in cents.
  // Price format matching the design: "590 AUD" — no symbol, space before ISO, no cents, grouped.
  M26.money = function (cents) {
    var amount = Math.round((cents || 0) / 100); // whole dollars, no cents
    var iso = cfg.currency || 'AUD';
    try {
      return amount.toLocaleString(document.documentElement.lang || 'en-AU') + ' ' + iso;
    } catch (e) {
      return amount + ' ' + iso;
    }
  };

  // Same value with the currency SYMBOL in front and no ISO — "$50", "£50", "€50".
  // Symbol picked from the cart's market currency (£ GBP, € EUR, $ for AUD/USD/NZD/…).
  // Used by the free shipping bar; product/cart prices keep M26.money's "590 AUD" style.
  M26.moneySym = function (cents) {
    var amount = Math.round((cents || 0) / 100);
    var iso = cfg.currency || 'AUD';
    var sym = iso === 'GBP' ? '£' : iso === 'EUR' ? '€' : '$';
    var n;
    try { n = amount.toLocaleString(document.documentElement.lang || 'en-AU'); }
    catch (e) { n = '' + amount; }
    return sym + n;
  };

  // Symbol + TWO decimals — "$112.50". Used for Afterpay instalment amounts.
  M26.moneyCents = function (cents) {
    var iso = cfg.currency || 'AUD';
    var sym = iso === 'GBP' ? '£' : iso === 'EUR' ? '€' : '$';
    var v = Math.round(cents || 0) / 100;
    var n;
    try { n = v.toLocaleString(document.documentElement.lang || 'en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
    catch (e) { n = v.toFixed(2); }
    return sym + n;
  };

  // Display-only title case for product names whose source is ALL CAPS.
  // Matches snippets/m26-title.liquid (lowercase, then capitalize each space-word).
  // Does NOT change any product data.
  M26.titleCase = function (s) {
    return (s == null ? '' : '' + s).toLowerCase().split(' ').map(function (w) {
      return w ? w.charAt(0).toUpperCase() + w.slice(1) : w;
    }).join(' ');
  };

  /* ---------- announcement rotation ---------- */
  function initAnnounce(){
    var wrap = $('.m26 .announce .slides');
    if (!wrap) return;
    var items = $all('span', wrap);
    if (items.length < 2){ if (items[0]) items[0].classList.add('on'); return; }
    var i = 0; items[0].classList.add('on');
    setInterval(function(){
      items[i].classList.remove('on');
      i = (i + 1) % items.length;
      items[i].classList.add('on');
    }, 4200);
  }

  /* ---------- scroll reveal ---------- */
  function initReveal(){
    var els = $all('.m26 [data-reveal]');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)){ els.forEach(function(e){ e.classList.add('in'); }); return; }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){ if (en.isIntersecting){ en.target.classList.add('in'); io.unobserve(en.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function(e){ io.observe(e); });
  }

  /* ---------- mega menu (hover) ---------- */
  function initMega(){
    var trigger = $('.m26 [data-mega-trigger]');
    var mega = $('.m26 #mega') || $('.m26 .mega');
    var navEl = $('.m26 .nav');
    if (!trigger || !mega || !navEl) return;
    trigger.addEventListener('mouseenter', function(){ mega.classList.add('open'); });
    $all('.nav-left .nav-link:not([data-mega-trigger])', navEl).forEach(function(l){
      l.addEventListener('mouseenter', function(){ mega.classList.remove('open'); });
    });
    navEl.addEventListener('mouseleave', function(){ mega.classList.remove('open'); });
  }

  /* ---------- search panel ---------- */
  function initSearch(){
    var panel = $('.m26 #searchPanel') || $('.m26 .search-panel');
    if (!panel) return;
    var input = $('#searchInput', panel) || $('input[type=search]', panel);
    var links = $('#searchLinks', panel) || $('.search-links', panel);
    var sub = $('.search-sub', panel);
    var DEFAULT_SUB = sub ? sub.textContent : 'Suggestions';

    function row(p){ return '<a href="' + localize(p.url) + '"><span>' + M26.titleCase(p.title) + '</span></a>'; }

    function suggestions(){
      if (sub) sub.textContent = DEFAULT_SUB;
      if (links) links.innerHTML = '';
    }

    var t;
    function search(q){
      q = (q || '').trim();
      if (!q){ suggestions(); return; }
      clearTimeout(t);
      t = setTimeout(function(){
        fetch(rootUrl('search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last'))
          .then(function(r){ return r.json(); })
          .then(function(data){
            var prods = (data.resources && data.resources.results && data.resources.results.products) || [];
            if (sub) sub.textContent = prods.length ? 'Results' : '';
            if (links) links.innerHTML = prods.length
              ? prods.map(row).join('')
              : '<div class="search-empty">No results for “' + q + '”.</div>';
          })
          .catch(function(){ if (links) links.innerHTML = ''; });
      }, 180);
    }

    function open(){ panel.classList.add('open'); document.body.style.overflow = 'hidden'; suggestions(); setTimeout(function(){ if (input) input.focus(); }, 60); }
    function close(){ panel.classList.remove('open'); document.body.style.overflow = ''; if (input) input.value = ''; }

    $all('[data-open-search]').forEach(function(b){ b.addEventListener('click', function(e){ e.preventDefault(); panel.classList.contains('open') ? close() : open(); }); });
    $all('[data-close-search]').forEach(function(b){ b.addEventListener('click', function(e){ e.preventDefault(); close(); }); });
    if (input) input.addEventListener('input', function(){ search(input.value); });
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape') close(); });
  }

  /* ---------- free shipping incentive bar ----------
     Reads M26.config.freeShip (enabled, threshold in cents for the cart's currency,
     and the two messages). Threshold is 0 when no amount is set for this market, in
     which case the bar stays hidden. Driven off the live AJAX cart total so it tracks
     quantity changes. The cart page renders its own copy server-side. */
  // Paint the bar's progress/message from the whole-bag total (all items count toward
  // the threshold, sale or not — the sale item is only the trigger).
  function paintShipBar(bar, fs, total, threshold){
    bar.removeAttribute('hidden');
    var msgEl = $('[data-ship-msg]', bar);
    var fillEl = $('[data-ship-fill]', bar);
    var remaining = threshold - total;
    if (remaining > 0){
      bar.classList.remove('is-complete');
      if (fillEl) fillEl.style.width = Math.min(100, (total / threshold) * 100) + '%';
      var tmpl = fs.msgProgress || 'Complimentary shipping — [amount] away';
      if (msgEl) msgEl.innerHTML = tmpl.replace('[amount]', '<b>' + M26.moneySym(remaining) + '</b>');
    } else {
      bar.classList.add('is-complete');
      if (fillEl) fillEl.style.width = '100%';
      if (msgEl) msgEl.textContent = fs.msgSuccess || 'Complimentary shipping unlocked';
    }
  }

  // True when the bag holds at least one marked-down item (variant price < compare-at).
  // Reuses productData() — the same per-product fetch the size dropdowns already cache.
  function cartHasSaleItem(cart){
    if (!cart || !cart.items || !cart.items.length) return Promise.resolve(false);
    return Promise.all(cart.items.map(function(it){
      return productData(it.handle).then(function(p){
        if (!p || !p.variants) return false;
        var v = p.variants.filter(function(x){ return x.id === it.variant_id; })[0];
        return !!(v && v.compare_at_price && v.compare_at_price > v.price);
      }).catch(function(){ return false; });
    })).then(function(flags){ return flags.some(Boolean); });
  }

  // True when the bag holds at least one full-price (NOT marked-down) item. Used to keep the
  // complimentary message on full-price + mixed bags and hide it only on sale-only bags.
  // Fails open (unknown product data counts as full price) so the offer isn't over-hidden.
  function cartHasFullPriceItem(cart){
    if (!cart || !cart.items || !cart.items.length) return Promise.resolve(false);
    return Promise.all(cart.items.map(function(it){
      return productData(it.handle).then(function(p){
        if (!p || !p.variants) return true;
        var v = p.variants.filter(function(x){ return x.id === it.variant_id; })[0];
        return !(v && v.compare_at_price && v.compare_at_price > v.price);
      }).catch(function(){ return true; });
    })).then(function(flags){ return flags.some(Boolean); });
  }

  function updateShipBar(cart){
    var bar = $('.m26 .drawer [data-ship-bar]');
    if (!bar) return;
    var fs = (M26.config && M26.config.freeShip) || {};
    var total = (cart && cart.total_price) || 0;
    var standard = +fs.threshold || 0;
    var sale = +fs.thresholdSale || 0;
    var trigger = fs.trigger || 'all';
    if (!fs.enabled || !cart || !cart.item_count){
      bar.setAttribute('hidden', '');
      return;
    }
    if (trigger === 'all'){
      if (standard > 0) paintShipBar(bar, fs, total, standard);
      else bar.setAttribute('hidden', '');
      return;
    }
    // 'sale' (gate) and 'split' (pick threshold) both depend on a sale item being present.
    bar.setAttribute('hidden', ''); // stay hidden until resolved
    cartHasSaleItem(cart).then(function(has){
      var threshold;
      if (trigger === 'sale'){
        if (!has){ bar.setAttribute('hidden', ''); return; }
        threshold = standard;
      } else { // 'split' — a marked-down item (incl. mixed bags) uses the sale threshold
        threshold = has ? sale : standard;
      }
      if (threshold > 0) paintShipBar(bar, fs, total, threshold);
      else bar.setAttribute('hidden', '');
    });
  }

  /* ---------- Afterpay instalment note ----------
     Returns the note markup (or '' when it shouldn't show) so render() can place it
     directly under the last bag item. "or N interest-free payments of $X.XX with
     Afterpay", off the live bag total, only in the configured currencies and below the
     optional cap. Display only — Afterpay eligibility is finalised at checkout. */
  function afterpayHTML(cart){
    var ap = (M26.config && M26.config.afterpay) || {};
    var iso = cfg.currency || 'AUD';
    var total = (cart && cart.total_price) || 0;
    var count = +ap.count || 4;
    var allowed = ('' + (ap.currencies || '')).toUpperCase().split(/[\s,]+/);
    var ok = ap.enabled && cart && cart.item_count && total > 0 && count > 0
          && allowed.indexOf(iso) !== -1
          && (!ap.maxCents || total <= ap.maxCents);
    if (!ok) return '';
    var per = M26.moneyCents(total / count);
    var msg = (ap.message || 'or [count] interest-free payments of [amount] with Afterpay')
      .replace('[count]', count).replace('[amount]', '<b>' + per + '</b>');
    return '<div class="ap-note ap-note-item">' + msg + '</div>';
  }

  /* ---------- cart drawer (Shopify AJAX) ---------- */
  var Cart = {
    state: null,
    open: function(){ var d = $('.m26 .drawer'), s = $('.m26 .scrim'); if (d) d.classList.add('on'); if (s) s.classList.add('on'); document.body.style.overflow = 'hidden'; },
    close: function(){ var d = $('.m26 .drawer'), s = $('.m26 .scrim'); if (d) d.classList.remove('on'); if (s) s.classList.remove('on'); document.body.style.overflow = ''; },
    fetch: function(){ return fetch(rootUrl('cart.js'), { headers: { 'Accept': 'application/json' } }).then(function(r){ return r.json(); }).then(function(c){ Cart.state = c; Cart.render(c); return c; }); },
    add: function(items){
      return fetch(rootUrl('cart/add.js'), {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function(r){ return r.json(); }).then(function(){ return Cart.fetch().then(function(c){ Cart.open(); return c; }); });
    },
    change: function(line, quantity){
      return fetch(rootUrl('cart/change.js'), {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      }).then(function(r){ return r.json(); }).then(function(c){ Cart.state = c; Cart.render(c); return c; });
    },
    swap: function(line, newVariantId, qty){
      // No atomic variant swap in the AJAX API: remove the old line, add the new variant, re-fetch.
      return fetch(rootUrl('cart/change.js'), {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: 0 })
      }).then(function(r){ return r.json(); })
        .then(function(){
          return fetch(rootUrl('cart/add.js'), {
            method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: newVariantId, quantity: qty }] })
          });
        })
        .then(function(r){ return r.json(); })
        .then(function(){ return Cart.fetch(); });
    },
    render: function(cart){
      cart = cart || Cart.state || { items: [], item_count: 0, total_price: 0 };
      updateShipBar(cart);
      // Complimentary-discount line + its savings line: when set to hide-on-sale-only-bags,
      // hide BOTH only when there's no full-price item (every item is marked down). They stay
      // on full-price and mixed bags, where the discount applies to the full-price items.
      var cdEl = $('.m26 .drawer [data-cart-discount]');
      if (cdEl && cdEl.getAttribute('data-cd-full-price-only') === 'true'){
        cartHasFullPriceItem(cart).then(function(hasFull){
          var savedEl = $('.m26 .drawer [data-cart-saved]');
          if (hasFull){
            cdEl.removeAttribute('hidden');
          } else {
            cdEl.setAttribute('hidden', '');
            if (savedEl) savedEl.setAttribute('hidden', '');
          }
        });
      }
      $all('[data-bag-count]').forEach(function(el){ el.textContent = cart.item_count; });
      $all('.m26 .bag-badge').forEach(function(el){ el.classList.toggle('is-empty', cart.item_count === 0); });
      var body = $('.m26 .drawer-body');
      var foot = $('.m26 .drawer-foot');
      if (!body) return;
      if (!cart.items.length){
        body.innerHTML = '<div class="drawer-empty"><div class="big">Your bag is empty</div><div class="label">As you browse, add pieces to build your selection.</div></div>';
        if (foot) foot.style.display = 'none';
        return;
      }
      if (foot) foot.style.display = '';
      body.innerHTML = cart.items.map(function(it, idx){
        var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') : '';
        return '' +
          '<div class="citem">' +
            '<a class="ci-media" href="' + localize(it.url) + '">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</a>' +
            '<div class="ci-body">' +
              '<a class="ci-name" href="' + localize(it.url) + '">' + M26.titleCase(it.product_title) + '</a>' +
              '<div class="ci-price">' + M26.money(it.original_line_price) + '</div>' +
              '<div class="ci-foot">' +
                '<div class="qty">' +
                  '<button data-line="' + (idx + 1) + '" data-dec aria-label="Decrease">−</button>' +
                  '<span>' + it.quantity + '</span>' +
                  '<button data-line="' + (idx + 1) + '" data-inc aria-label="Increase">+</button>' +
                '</div>' +
                '<select class="ci-size-sel" data-size-sel="' + (idx + 1) + '" aria-label="Change size" disabled>' +
                  '<option selected>' + (it.variant_title || '') + '</option>' +
                '</select>' +
              '</div>' +
            '</div>' +
          '</div>';
      }).join('') + afterpayHTML(cart);
      if (foot){
        var tot = $('[data-bag-total]', foot);
        if (tot){
          if (cart.original_total_price > cart.total_price){
            tot.innerHTML = '<s class="cart-was">' + M26.money(cart.original_total_price) + '</s>' + M26.money(cart.total_price);
          } else {
            tot.textContent = M26.money(cart.total_price);
          }
        }
        var saved = $('[data-cart-saved]', foot);
        if (saved){
          var diff = (cart.original_total_price || 0) - (cart.total_price || 0);
          if (diff > 0){ saved.innerHTML = '<b>' + M26.money(diff) + '</b> saved'; saved.removeAttribute('hidden'); }
          else { saved.setAttribute('hidden', ''); }
        }
      }
      $all('[data-inc]', body).forEach(function(b){ b.onclick = function(){ var l = +b.getAttribute('data-line'); Cart.change(l, Cart.state.items[l - 1].quantity + 1); }; });
      $all('[data-dec]', body).forEach(function(b){ b.onclick = function(){ var l = +b.getAttribute('data-line'); Cart.change(l, Cart.state.items[l - 1].quantity - 1); }; });
      enhanceSizes(cart);
      enhanceSalePrices(cart);
    }
  };
  M26.cart = Cart;

  /* ---------- Per-line size dropdown (real variants + availability) ----------
     Each cart line gets a native <select> of the product's actual sizes. Only
     sizes that exist for the line's *other* selected options are listed; sold-out
     variants are disabled. Changing it swaps the line to that variant. */
  var productCache = {};
  function productData(handle){
    if (!handle) return Promise.resolve(null);
    if (productCache[handle]) return productCache[handle];
    productCache[handle] = fetch(rootUrl('products/' + handle + '.js'), { headers: { 'Accept': 'application/json' } })
      .then(function(r){ return r.ok ? r.json() : null; })
      .catch(function(){ return null; });
    return productCache[handle];
  }
  function optionName(o){ return (typeof o === 'string') ? o : (o && o.name) || ''; }
  // Sale markdown only: when a line's variant has a compare-at price above its price,
  // strike the RRP. Keyed off compare-at (a real markdown), NOT the order-discount
  // allocation — so the complimentary discount never adds a line-level strike. Uses the
  // market-aware product JSON (already cached for the size dropdowns) so amounts are in
  // the cart's currency.
  function enhanceSalePrices(cart){
    var body = $('.m26 .drawer-body');
    if (!body) return;
    var cells = $all('.ci-price', body);
    cart.items.forEach(function(it, idx){
      var cell = cells[idx];
      if (!cell || !it.handle) return;
      productData(it.handle).then(function(p){
        if (!p || !p.variants) return;
        var v = p.variants.filter(function(x){ return x.id === it.variant_id; })[0];
        if (v && v.compare_at_price && v.compare_at_price > v.price){
          cell.innerHTML = '<s class="cart-was">' + M26.money(v.compare_at_price * it.quantity) + '</s>' + M26.money(it.original_line_price);
        }
      });
    });
  }
  function enhanceSizes(cart){
    var body = $('.m26 .drawer-body');
    if (!body) return;
    var selects = $all('.ci-size-sel', body);
    cart.items.forEach(function(it, idx){
      var sel = selects[idx];
      if (!sel || !it.handle) return;
      productData(it.handle).then(function(product){
        if (!product || !product.variants || !product.variants.length) return;
        var names = (product.options || []).map(optionName);
        var sizeIdx = -1;
        for (var i = 0; i < names.length; i++){ if (/size/i.test(names[i])){ sizeIdx = i; break; } }
        if (sizeIdx === -1){ if (names.length === 1){ sizeIdx = 0; } else { return; } } // no size option → leave as-is
        var current = it.variant_id;
        var curVar = product.variants.filter(function(v){ return v.id === current; })[0];
        var curOpts = curVar ? [curVar.option1, curVar.option2, curVar.option3] : [];
        var seen = {}, opts = [];
        product.variants.forEach(function(v){
          var vOpts = [v.option1, v.option2, v.option3], ok = true;
          for (var j = 0; j < names.length; j++){ if (j !== sizeIdx && vOpts[j] !== curOpts[j]){ ok = false; break; } }
          if (!ok) return;
          var val = vOpts[sizeIdx];
          if (val == null || seen[val]) return;
          seen[val] = true;
          opts.push({ value: val, id: v.id, available: v.available });
        });
        if (!opts.length) return;
        sel.innerHTML = opts.map(function(o){
          return '<option value="' + o.id + '"' + (o.id === current ? ' selected' : '') + (o.available ? '' : ' disabled') + '>' +
            o.value + (o.available ? '' : ' — Sold out') + '</option>';
        }).join('');
        sel.removeAttribute('disabled');
        sel.onchange = function(){
          var newId = +sel.value;
          if (!newId || newId === current) return;
          Cart.swap(+sel.getAttribute('data-size-sel'), newId, it.quantity);
        };
      });
    });
  }

  function initCart(){
    if (!$('.m26 .drawer')) return;
    Cart.fetch();
    $all('[data-open-bag]').forEach(function(b){ b.addEventListener('click', function(e){ e.preventDefault(); Cart.open(); }); });
    $all('[data-close-bag]').forEach(function(b){ b.addEventListener('click', function(e){ e.preventDefault(); Cart.close(); }); });
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape') Cart.close(); });
    // Progressive enhancement: intercept any [data-m26-add] form/button to add via AJAX.
    $all('[data-m26-add]').forEach(function(form){
      form.addEventListener('submit', function(e){
        e.preventDefault();
        var id = form.querySelector('[name="id"]');
        var qtyEl = form.querySelector('[name="quantity"]');
        if (!id) return;
        Cart.add([{ id: +id.value, quantity: qtyEl ? +qtyEl.value : 1 }]);
      });
    });
  }

  /* ---------- Saved / wishlist (localStorage) ---------- */
  var SK = 'm26_saved_v1';
  var Saved = {
    items: (function(){ try { return JSON.parse(localStorage.getItem(SK)) || []; } catch(e){ return []; } })(),
    save: function(){ try { localStorage.setItem(SK, JSON.stringify(this.items)); } catch(e){} },
    has: function(handle){ return this.items.some(function(x){ return x.handle === handle; }); },
    toggle: function(item){
      var i = -1;
      for (var k = 0; k < this.items.length; k++){ if (this.items[k].handle === item.handle){ i = k; break; } }
      if (i < 0) this.items.push(item); else this.items.splice(i, 1);
      this.save();
      return this.has(item.handle);
    },
    list: function(){ return this.items; }
  };
  M26.saved = Saved;

  // Collection size-on-hover + any [data-m26-add-variant] button → add a real variant.
  function initAddButtons(){
    document.addEventListener('click', function(e){
      var b = e.target.closest && e.target.closest('[data-m26-add-variant]');
      if (!b) return;
      e.preventDefault();
      var id = +b.getAttribute('data-m26-add-variant');
      if (id) Cart.add([{ id: id, quantity: 1 }]);
    });
  }

  // [data-m26-save] toggles a product in the Saved store and reflects label state.
  function initSaveButtons(){
    function sync(btn){
      var on = Saved.has(btn.getAttribute('data-handle'));
      btn.classList.toggle('is-saved', on);
      var label = on ? btn.getAttribute('data-saved-label') : btn.getAttribute('data-unsaved-label');
      if (label) btn.textContent = label;
    }
    $all('[data-m26-save]').forEach(function(btn){
      sync(btn);
      btn.addEventListener('click', function(e){
        e.preventDefault();
        Saved.toggle({
          handle: btn.getAttribute('data-handle'),
          title: btn.getAttribute('data-title'),
          price: btn.getAttribute('data-price'),
          image: btn.getAttribute('data-image'),
          alt: btn.getAttribute('data-alt') || '',
          url: btn.getAttribute('data-url')
        });
        sync(btn);
      });
    });
  }

  // Saved page grid: render the Saved store into [data-m26-saved-grid].
  function initSavedGrid(){
    var host = $('.m26 [data-m26-saved-grid]');
    if (!host) return;
    function render(){
      var items = Saved.list();
      if (!items.length){
        host.innerHTML = '<div class="sv-empty"><p>As you browse, save items to build your selection.</p></div>';
        return;
      }
      host.innerHTML = '<div class="sv-grid">' + items.map(function(p){
        return '<div class="pcard-wrap">' +
          '<a class="pcard" href="' + localize(p.url) + '">' +
            '<div class="pcard-media">' + (p.image ? '<img class="ph-img" src="' + p.image + '" alt="' + (p.alt || '') + '">' : '') + '</div>' +
            '<div class="pcard-info"><div class="pcard-name">' + M26.titleCase(p.title) + '</div><div class="pcard-price">' + (p.price || '') + '</div></div>' +
          '</a>' +
          '<button class="sv-remove" data-rm="' + p.handle + '">Remove</button>' +
        '</div>';
      }).join('') + '</div>';
      $all('[data-rm]', host).forEach(function(b){
        b.addEventListener('click', function(){ Saved.toggle({ handle: b.getAttribute('data-rm') }); render(); });
      });
    }
    render();
  }

  ready(function(){
    initAnnounce();
    initReveal();
    initMega();
    initSearch();
    initCart();
    initAddButtons();
    initSaveButtons();
    initSavedGrid();
  });
})();
